import React from "react";
import {NavLink} from "react-router-dom";
import photo from "../../photos/Dashboard Logo.png";
import Icon from "../atoms/Icon";
import {useStateContext} from "../../context/AdminDashboard/MainContext";
import ModalProfile from "./ModalProfile";
import DeleteModal from "../atoms/DeleteModal";
import {Toaster} from "react-hot-toast";

// CSS classes
const defaultActiveNavLinkClassName = "flex flex-row   text-14 leading-6 font-medium hover:bg-gray-side relative cursor-pointer";
const defaultSubMenuClassName = "leading-6 h-11 text-14 font-medium w-full pt-1.4 relative hover:bg-gray-side pr-5 before:content-[''] before:h-1.5 before:bg-white before:inline-block before:rounded-full before:ml-2.5 before:w-1.5 cursor-pointer";

const Sidebar = () => {
    const {
        user, profile, logout, showlogout, closelogout, logoutmodal, getSidebar,
    } = useStateContext();

    return (<>
        {/* Sidebar content */}
        <div
            className="z-1 fixed flex-col flex bg-main-blue-300  text-white w-235 ml-auto h-100 bg-side-pattern bg-no-repeat  right-0"
            dir="rtl">

            <div className="flex justify-center flex-col items-center mt-12">
                <div className="w-79 h-79">
                    <img className=" h-full w-full  object-cover" src={photo} alt=""/>
                </div>
                <p className="text-14 leading-6 mt-10 font-medium ">{user.name}</p>
                <span
                    className="text-12 leading-5 mt-.3  tracking-wider"
                    typeof="number">
            {user.number}
          </span>
                <div className="mt-5 border-b-1 border-b-grayl">
                    <button
                        className="text-12 w-91 h-38 mb-10.1 bg-gray-side rounded-tr-sm rounded-br-sm ml-.2"
                        onClick={profile}>
                        پروفایل
                    </button>
                    <button
                        className="text-12 w-91 h-38 mb-10.1 bg-gray-side rounded-tl-sm rounded-bl-sm"
                        onClick={logoutmodal}>
                        خروج
                    </button>
                </div>
            </div>

            <div className="flex flex-col h-auto  mt-4.9">
                {user.links.map((link, index) => {
                    const LinkComponent = link.subMenus ? LinkWithSubMenu : LinkWithoutSubMenu;
                    const props = {
                        to: link.path, title: index,
                    };
                    return (<LinkComponent {...props} key={index}>
                  <span
                      className={` flex flex-row  pr-5.5 pl-5.5  items-center gap-2.5`}
                      dir="rtl"
                      index={index}>
                    <Icon className="h-5 w-5" iconName={link.icon}/>
                      {link.title}
                      {link.subMenus && (<Icon
                          className="absolute left-7.5px"
                          iconName={"arrow-left"}
                      />)}
                      {/* Render submenus */}
                      {link.subMenus && (
                          <ul className="absolute bg-main-blue-300 mr-56.5 w-220 flex flex-col  pt-3.5 rounded-sm list-disc pb-3.5 top-0 hidden before:bg-white before:p-2px before:h-32 before:w-0.4 before:top-0 before:absolute">
                              {link.subMenus.map((sub, index) => {
                                  return (<NavLink
                                      as="li"
                                      key={index}
                                      to={sub.path}
                                      className={({isActive}) => isActive ? defaultSubMenuClassName + `bg-gray-side` : defaultSubMenuClassName}>
                                      {sub.title}
                                  </NavLink>);
                              })}
                          </ul>)}
                  </span>
                    </LinkComponent>);
                })}
            </div>
        </div>
        {/* Modals and toasts */}
        <div dir="rtl">
            <ModalProfile userData={user} roleIsUser={false}/>
            <DeleteModal
                text={`آیا برای خارج شدن مطمئن هستید؟
        `}
                showDeleteModal={showlogout}
                closeDeleteModal={closelogout}
                RemoveItem={logout}
                logout={true}
                title={"اخطار خروج "}
            />
            <Toaster/>
        </div>
    </>);
};

// Component for links without submenus
const LinkWithoutSubMenu = (props) => {
    return (<NavLink
        to={props.to}
        className={"flex flex-row hover:bg-gray-side items-center h-[40px] relative my-[2px]"} // ارتفاع ثابت 40px
    >
        {({isActive}) => (<>
            {isActive && <Icon iconName={"sidebar-active"} className={"absolute right-0"}/>}

            {props.children}
        </>)}
    </NavLink>);
};

// Component for links with submenus
const LinkWithSubMenu = (props) => {
    const {handleMouseLeave, handleMouseEnter} = useStateContext();
    return (<div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`${defaultActiveNavLinkClassName} h-[40px] my-[2px]`} // ارتفاع ثابت 40px
    >
        {props.children}
    </div>);
};
export default Sidebar;
